import * as actions from '../actions/saleItemsActions';

export const initialState = {
  saleItems: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SALE_ITEMS:
      /**
       * Faster than state.saleItems.toString() === action.payload.toString()
       */
      const update = (
        (state.saleItems.length === 0 && action.payload.length === 0) ||
        (state.saleItems.length !== action.payload.length) || // Short circuit
        (state.saleItems.filter(saleItem => {
          return action.payload.filter(item => {
            return (
              saleItem.id === item.id &&
              saleItem.remainingItems === item.remainingItems &&
              saleItem.startTime === item.startTime &&
              saleItem.endTime === item.endTime &&
              saleItem.price === item.price
            );
          }).length > 0;
        }).length !== action.payload.length)
      );

      return {
        ...state,
        saleItems: (update) ? action.payload : state.saleItems
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/saleItemsReducer.js